module.exports = __webpack_public_path__ + "img/05.43436e33.jpg";